<template>
  <div class="rt-address-recognition">
    <rt-form
      :model="editForm"
      border
    >
      <rt-form-item hidden-label>
        <rt-input
          v-model="editForm.text"
          type="textarea"
          :placeholder="placeholder"
          :autosize="{ minRows: 3, maxRows: 5 }"
        >
          <template slot="textareaSuffix">
            <slot name="button">
              <rt-button
                type="plain"
                class="el-input__count"
                text
                @click="onClick"
              >
                {{ buttonText }}
              </rt-button>
            </slot>
          </template>
        </rt-input>
      </rt-form-item>
    </rt-form>
    <div class="rt-address-recognition-tips">
      {{ tips }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtAddressRecognition',
  props: {
    tips: {
      type: String,
      default () {
        return this.$tx('示例：王传福，136xxxx9876，江苏省苏州市虎丘区xx号xx小区');
      }
    },
    buttonText: {
      type: String,
      default () {
        return this.$tx('识别', 'xpc.address.parse');
      }
    },
    placeholder: {
      type: String,
      default () {
        return this.$tx('请输入', 'xpc.form.pleaseEnter');
      }
    },
    successMsg: {
      type: String,
      default () {
        return this.$tx('识别成功', 'xpc.address.successMsg');
      }
    },
    errorMsg: {
      type: String,
      default () {
        return this.$tx('识别失败，请填写正确的格式', 'xpc.address.errorMsg');
      }
    }
  },
  data () {
    return {
      editForm: {
        text: ''
      }
    };
  },
  methods: {
    onClick () {
      rt.parseAddress(this.editForm.text)
        .then(result => {
          this.$emit('parse', result);
          this.$message({
            message: this.successMsg,
            type: 'success'
          });
        })
        .catch(() => {
          this.$message({
            message: this.errorMsg,
            type: 'error'
          });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtRecognition.vue?6e0d9790